export const listApplicationProducts = `
   query listApplicationProducts($filter:ApplicationProductsFilterInput, $limit: Int, $nextToken: String) {
       listApplicationProducts(filter:$filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              applicationId
              productId
              product {
                  id
                  name
                  shortDescription
                  prices {
                      items {
                          id
                          amount
                          billingPeriod
                      }
                      nextToken
                  }
                  lineItems {
                      items {
                          id
                          productFeature {
                              id
                              name
                          }
                      }
                      nextToken
                  }
                  freeTrial
              }
              applicationProductStatus
              position
              created
              updated
           }
           nextToken
       }
   }
`;


export const getApplicationProduct = `
   query getApplicationProduct($id:ID!) {
       getApplicationProduct(id:$id) {
         id
         applicationId
         productId
         product {
             id
             name
         }
         applicationProductStatus
         position
         created
         updated
       } 
}`;
